export default __webpack_public_path__ + "static/media/tele.17ae54b9.png";